export const CHANGE_JURIDICAL_PERSON_DATA = 'CHANGE_JURIDICAL_PERSON_DATA';
export type CHANGE_JURIDICAL_PERSON_DATA = typeof CHANGE_JURIDICAL_PERSON_DATA;


// WEBPACK FOOTER //
// ./src/actions/juridical-person/change-data/Types.tsx